var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailedMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 32.5,
    viewBox: "0 0 26 32.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "where_to_vote_FILL1_wght400_GRAD0_opsz48",
    d: "M21,36.5a54.021,54.021,0,0,1-9.77-10.339Q8,21.387,8,17.325a12.567,12.567,0,0,1,3.92-9.709,13.208,13.208,0,0,1,18.159,0A12.567,12.567,0,0,1,34,17.325q0,4.063-3.23,8.836A54.021,54.021,0,0,1,21,36.5Z",
    transform: "translate(-8 -4)",
    fill: "#F04444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 5.71a.9959.9959 0 0 0-1.41 0L12 10.59 7.11 5.7a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z",
    transform: "translate(1 2)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedMarker);
export default __webpack_public_path__ + "static/media/failed-marker.a8a08cf1d45b68cfa8402f9b04ce48b3.svg";
export { ForwardRef as ReactComponent };